/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isFunction from 'lodash/isFunction';
import omit from 'lodash/omit';

import { ButtonGroup, Button } from 'uikit/buttons';

import styles from '../styles/uikitModalsModalActions.module.scss';

const ModalActions = ({
  actions = [],
  formState,
  hasFormError,
  isFullScreen,
  modalData,
  onActionClicked = () => {},
}) => {
  if (actions.length === 0) return null;

  return (
    <div
      className={classnames(styles.element, {
        [styles.isFullScreen]: isFullScreen,
      })}
    >
      <ButtonGroup>
        {actions.map((action, index) => {
          if (!action.element || action.element === 'button') {
            if (action.getIsDisabled && isFunction(action.getIsDisabled)) {
              action.isDisabled = action.getIsDisabled({
                modalData,
                hasFormError,
                formState,
              });
            }

            const buttonProps = omit(action, ['callback', 'getIsDisabled']);

            return (
              <Button
                key={index}
                size="medium"
                {...buttonProps}
                onClick={
                  action.onClick
                    ? action.onClick
                    : () => onActionClicked(action)
                }
              />
            );
          }

          if (action.element === 'link' && action.href) {
            return (
              <a
                key={index}
                href={action.href}
                {...action}
              >
                {action.text}
              </a>
            );
          }
        })}
      </ButtonGroup>
    </div>
  );
};

ModalActions.propTypes = {
  modalData: PropTypes.shape({}).isRequired,
  actions: PropTypes.array,
  formState: PropTypes.shape({}).isRequired,
  hasFormError: PropTypes.bool.isRequired,
  onActionClicked: PropTypes.func,
};

export default ModalActions;
